export const getParentPath = (current, n = 1) => {
  let parent = current
  for (let i = 0; i < n; i++) {
    parent = parent.substring(0, parent.lastIndexOf('/'))
  }
  return parent
}
